import { createMongoAbility, MongoAbility } from '@casl/ability';

export type Action = 'manage' | 'create' | 'read' | 'update' | 'delete';
export type Subject =
  | 'all'
  | 'User'
  | 'Business'
  | 'Analytics'
  | 'Category'
  | 'Filter'
  | 'Notification'
  | 'AppVersion'
  | 'UserEvent';

export type AppAbility = MongoAbility<[Action, Subject]>;

export const createAbility = (
  rules: Array<{
    action: Action | Action[];
    subject: Subject;
    conditions?: Record<string, string | number | boolean>;
  }> = [],
): AppAbility => {
  return createMongoAbility(rules);
};

export const can = (
  ability: AppAbility | null,
  action: Action,
  subject: Subject,
): boolean => {
  if (!ability) return false;
  return ability.can(action, subject);
};

export const cannot = (
  ability: AppAbility | null,
  action: Action,
  subject: Subject,
): boolean => {
  return !can(ability, action, subject);
};
